import React from 'react'

const Subtitle2 = ({ className, ...rest }: any) => (
  <p {...rest} className={`kogan-text-subtitle2 ${className}`} />
)

export default Subtitle2
